import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

const Loader = ({
  size = 30, absolute, color = 'primary', sx, ...props
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        ...(absolute && {
          position: 'absolute',
          top: '50%',
          left: 0,
          transform: 'translateY(-50%)'
        }),
        ...sx
      }}
      {...props}>
      <CircularProgress size={size} color={color} />
    </Box>
  );
};

export default Loader;
